import { toast } from "react-toastify";
import { formatDate } from "../../utils/rawData/dateValues";
import { ClientTypeColor, PercetageColor, GetStatusClass, PlanBackgroundColor, GetDynamicColor, formMapColor, facturacionMapColor, infoEnviadaMapColor, delayResponsibleMapColor, capacitacionHechaMapColor, statusColorMap } from "../../utils/GetTextColor";
import DetailsButton from "../ui/components/DetailsButton";
import { FaComment, FaExternalLinkAlt, FaEye, FaEyeSlash } from "react-icons/fa";
import Tooltip from "../ui/ToolTip";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import { useRef, useState, useEffect } from "react";
import HandleUpdateSelectSelf from "../../utils/HandleUpdateSelectSelf";
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import { serviceStatus } from "../../utils/rawData/serviceStatus";
import IdButton from "../ui/components/IdButton";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import OpcionesRecompraPotencial from "../../utils/plainValues/OpcionesRecompraPotencial";
import DinamicBoxButton from "../ui/components/DinamicBoxButton";
import { SiGoogledrive } from "react-icons/si";
import React from "react";
import { createPortal } from "react-dom";
import DrawerCotizacionCalendarioPagosDetails from "../calendarioPagos/DrawerCotizacionCalendarioPagosDetails";


const SoftwareRowItemContainer = ({sticky, second, serviceData, key, c, activeCols, shouldShowColumn, stickyOffsets, user, permissions, setOpenModalDescription, setSelectedService, setOpenModalComments, softwareServices, setClients }) => {

  const [s, setS] = useState(serviceData)
  
  // Mantener sincronizado el estado local con los cambios del padre
  useEffect(() => {
    setS(serviceData)
  }, [serviceData])
  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  // Drawer cotización
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(null);

  const handleOpenDrawer = async (id) => {
    try {
      const response = await axios.get(`${BACKEND}/api/cotizaciones/${id}`)
      setDataDrawer(response.data)
      setOpenDrawer(true)
    } catch (error) {
      toast.error("Error al obtener la cotización")
    }
  }

  const formStatus = s.form ? s.form.respondido ? "Respondido" : "No respondido" : "No asignado"
  const clientType = s.cotizacion?.cliente?.tipoCliente ? s.cotizacion?.cliente?.tipoCliente : "No definido"
  const facturacion = s.facturacion ? s.facturacion : "No definido"
  const checklistCompleted = s.checklistCompleted || s.checkList === "Si" ? "Si" : "No"

  const linkDesarrollo = s?.links?.find((l) => l.titulo === "Link demo")?.url
  const linkOficial = s?.links?.find((l) => l.titulo === "Link web oficial")?.url

  const linkDisenioGrafico = s.linkDisenioGrafico || ""
  const linkGithub = s.linkGithub || ""
  const linkFlujo = s.linkFlujo || ""
  const linkRoadmap = s.linkRoadmap || ""
  const linkEsquemaBaseDatos = s.linkEsquemaBaseDatos || ""
  const linkManualUso = s.linkManualUso || ""
  const webReferencia = s.webReferencia || ""
  const copiaSeguridadRef = s.copiaSeguridadReferencia || ""
  const linkCapacitacion = s.linkCapacitacion || ""

  const folderCreated = s.folderCreated || false
  const folderId = s.folderId || ""
  const driveUrl = folderCreated && folderId ? `https://drive.google.com/drive/folders/${folderId}` : null

  // Modificación de seleccionables, ya no es solo lectura
  const handleUpdateField = async (field, newStatus) => { // Cambiar el campo
    const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

    const newChange = {
      worker: user,
      field: field,
      oldValue: s[field],
      newValue: newStatus,
      date: new Date().toISOString(),
    };

    changeHistory.push(newChange);

    const transformedHistory = changeHistory.map(change => ({
      ...change,
      worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
    }));

    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
        [field]: newStatus === "Seleccionar" ? null : newStatus,
        historialCambios: transformedHistory, // Enviar el array actualizado
      });

      // Crear el servicio actualizado
      const updatedService = {
        ...s,
        [field]: newStatus,
        historialCambios: changeHistory,
      };

      // Actualizar el estado local
      setS(updatedService);

      // Actualizar el servicio específico en el array de clientes
      setClients((prevClients) => 
        prevClients.map(client => 
          client.id === c.id 
            ? {
                ...client,
                services: client.services.map(service => 
                  service.id === s.id ? updatedService : service
                )
              }
            : client
        )
      );

      toast.success("Estado actualizado con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar el estado");
    }
  };

  // Modificación de inputs, ya no es solo lectura
  const handleUpdateDate = (field, newDate) => { // Cambiar la fecha con lógica de debouncer

    setS((prevData) => ({
      ...prevData,
      [field]: newDate,
    }));

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {
        const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

        const newChange = {
          worker: user,
          field: field,
          oldValue: s[field],
          newValue: newDate,
          date: new Date().toISOString(),
        };

        changeHistory.push(newChange);

        const transformedHistory = changeHistory.map(change => ({
          ...change,
          worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
        }));

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
          [field]: newDate || null,
          historialCambios: transformedHistory, // Enviar el array actualizado
        });

        // Crear el servicio actualizado
        const updatedService = {
          ...s,
          [field]: newDate,
          historialCambios: changeHistory,
        };

        // Actualizar el estado local
        setS(updatedService);

        // Actualizar el servicio específico en el array de clientes
        setClients((prevClients) => 
          prevClients.map(client => 
            client.id === c.id 
              ? {
                  ...client,
                  services: client.services.map(service => 
                    service.id === s.id ? updatedService : service
                  )
                }
              : client
          )
        );

        toast.success("Dato actualizado con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 1000); // Esperar 1 sec luego de que el usuario deja de escribir
  };

  // Column definitions (ordered). IDs are assigned automatically as index + 1
  const cols = [
    // 1) Cotización
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-[3.5rem] min-w-[3.5rem] w-[3.5rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } z-10 sticky border border-gray-300 truncate text-center font-semibold hover:cursor-pointer hover:underline transition-all duration-100`} style={{ left: stickyOffsets?.first || '0rem' }}>
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              content={"Abrir cotización"}
              type="eye"
              action={() => handleOpenDrawer(s.cotizacion?.id)}
            />
          </div>
        </td>
      ),
    },

    // 2) Porcentaje proyecto
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-[6.2rem] min-w-[6.2rem] w-[6.2rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } z-10 max-w-xs sticky border border-gray-300 truncate font-bold text-center ${GetDynamicColor(s.porcentajeAvance, PercetageColor)}`} style={{ left: stickyOffsets?.second || '3.5rem' }}>
          <input
            type="number"
            value={s.porcentajeAvance ? s.porcentajeAvance : 0}
            min={0}
            max={100}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              let value = parseInt(e.target.value, 10);
              if (isNaN(value)) value = 0;
              if (value < 0) value = 0;
              if (value > 100) value = 100;
              handleUpdateDate("porcentajeAvance", value);
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300 w-full ${GetDynamicColor(s.porcentajeAvance, PercetageColor)}`}
          />
        </td>
      ),
    },

    // 3) Cliente
    {
      content: () => (
        <td scope="row" className={`${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } sticky z-10 px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-start hover:cursor-pointer hover:underline transition-all duration-100`} style={{ left: stickyOffsets?.third || '9.7rem' }}>
          <a href={`/home/seguimiento/${c.id}`} target="_blank" rel="noopener noreferrer">
            <span title={c.nombreComercial} className="whitespace-nowrap text-xs">{c.nombreComercial}{c.vip === "Si" && " ⭐"}</span>
          </a>
        </td>
      ),
    },

    // 4) Ir al proyecto
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <a 
              href={`/home/seguimiento/${serviceData.cotizacion.cliente.id}/${serviceData.servicio.name}/${serviceData.id}`}
              target="_blank" 
              rel="noopener noreferrer"
              className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
            >
              <DetailsButton content={"Ir al proyecto"} type="externalLink"/>
            </a>
          </div>
        </td>
      ),
    },

    // 5) Link Drive
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            <DinamicBoxButton
              color={folderCreated && folderId ? "blue" : "gray"}
              action={folderCreated && folderId ? () => {window.open(driveUrl, "_blank", "noopener,noreferrer")} : null}
              content={driveUrl ? driveUrl : "No hay link de Drive"}
              icon={folderCreated && folderId ? <SiGoogledrive className="text-blue-500" /> : <FaEyeSlash className="text-gray-500"/>}
            />
          </div>
        </td>
      ),
    },

    // 5) Recompra potencial
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs ${s.debt ? "bg-red-200" : "bg-white" } border border-gray-300 truncate text-center`}>
          <select
            value={s.cotizacion?.cliente?.recompraPotencial}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              HandleUpdateSelect("recompraPotencial", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, recompraPotencial: e.target.value }
                }
              }))
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            {OpcionesRecompraPotencial.map((value) => (
              <option value={value.value} className={`${value.color}`}>{value.icon} {value.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 6) Moroso
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs border border-gray-300 truncate text-center`}>
          <div className="flex justify-center items-center gap-2">
            {s.debt ? (
              <span className="text-red-500 font-bold">Si</span>
            ) : (
              <span className="text-gray-200">No</span>
            )}
          </div>
        </td>
      ),
    },

    // 7) ID Cotización
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <IdButton content={s.cotizacion.id} type="id" action={() => {CopyToClipBoard(s.cotizacion.id)}} />
          </div>
        </td>
      ),
    },

    // 8) Servicio
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          {s.servicio.name}
        </td>
      ),
    },

    // 9) Estado
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 border border-gray-300 text-center align-middle`}>
          <select
            value={s.estado}
            onChange={(e) => {
              const newValue = e.target.value
              const missingFields = !s.delayResponsible || s.delayResponsible === "Por definir" || !s?.linkCapacitacion
              if (((!permissions.isAdmin && !permissions.isAssistant && !permissions.isBossArea) || missingFields) && newValue === "Terminado con exito") {
                toast.error("Para colocar en estado 'Éxito', debe completar responsable de retraso y link de capacitación.")
                return
              }
              handleUpdateField("estado", newValue)
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300 
              ${(!permissions.isAdmin && !permissions.isBossArea) ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}
              ${statusColorMap[s.estado] || ""}
            `}
            disabled={(!permissions.isAdmin && !permissions.isBossArea) && s.estado !== "Terminado con exito"}
            title={(!permissions.isAdmin && !permissions.isBossArea)? "No tienes permiso para editar el estado" : ""}
          >
            {serviceStatus.map((status) => (
              <option value={status.value} className={`${status.color}`}>{status.icon} {status.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 10) Formulario
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs border font-bold border-gray-300 truncate text-center`}>
          <div className="flex justify-center items-center gap-2">
              {formStatus === "Respondido" ? (
                <a 
                  href={`/home/seguimiento/encuestas-respuestas/${s.form.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DetailsButton content={"Abrir formulario"} type="externalLink"/>
                </a>
              ) : (
                <Tooltip content={formStatus} >
                  <div>
                    <FaEyeSlash className="text-gray-500"/>
                  </div>
                </Tooltip>
              )}
          </div>
        </td>
      ),
    },

    // 11) Descripción servicio
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              action={() => {setOpenModalDescription(true); setSelectedService(s)}}
              content={"Abrir descripción del servicio"}
            />
          </div>
        </td>
      ),
    },

    // 12) Comentarios vendedor
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            {s.comentarioVendedor ? (
              <Tooltip content={s.comentarioVendedor} interactive={true}>
                <div className="flex justify-center items-center text-gray-800 hover:cursor-pointer">
                  <FaComment />
                </div>
              </Tooltip>
            ) : (
              <div className="flex justify-center items-center text-gray-200">
                <FaComment />
              </div>
            )}
          </div>
        </td>
      ),
    },

    // 13) Comentarios operativa
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DinamicBoxButton
              color={s?.comentariosOperativa?.length > 0 ? "blue" : "gray"}
              action={() => {setOpenModalComments(true); setSelectedService(s)}}
              content={`Abrir comentarios del área operativa: ${s?.comentariosOperativa?.length > 0 ? `${s?.comentariosOperativa?.length}` : "0"}`}
              icon={s?.comentariosOperativa?.length > 0 ? <FaEye /> : <FaEyeSlash />}
            />
          </div>
        </td>
      ),
    },

    // 14) Plan
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`font-semibold px-2 ${PlanBackgroundColor[s.planServicio.name]}`}>
            {s.planServicio.name}
          </span>
        </td>
      ),
    },

    // 15) Encargado
    {
      content: () => (
        <td scope="row" className="max-w-[11rem] px-2 py-1 max-w-xs border border-gray-300 truncate text-start">
          <span title={s.cotizacion?.cliente?.encargadoProyecto}>{s.cotizacion?.cliente?.encargadoProyecto ? `${s.cotizacion?.cliente?.encargadoProyecto}` : "-"}</span>
        </td>
      ),
    },

    // 16) Nro encargado
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.cotizacion?.cliente?.telefono ? `${s.cotizacion?.cliente?.telefono}` : "-"}
        </td>
      ),
    },

    // 17) Tipo cliente
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.cotizacion?.cliente?.tipoCliente}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              HandleUpdateSelect("tipoCliente", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, tipoCliente: e.target.value }
                }
              }))
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            <option value="No definido" className="text-gray-500">⚫ No definido</option>
            <option value="Amable" className="text-green-500">🟢	Amable</option>
            <option value="Normal" className="text-blue-500">🔵	 Normal</option>
            <option value="Problematico" className="text-red-500">🔴	 Problematico</option>
          </select>
        </td>
      ),
    },

    // 18) Responsable
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.responsable?.name ? `${s.responsable?.name}` : "-"}
        </td>
      ),
    },

    // 19) Checklist
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${checklistCompleted === "Si" ? "text-green-500" : "text-red-500"}`}>
            {checklistCompleted}
          </span>
        </td>
      ),
    },

    // 20) Fecha venta o ingreso
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.fechaIngreso ? formatDate(s.fechaIngreso.split("T")[0]) : "-"}
        </td>
      ),
    },

    // 21) Fecha inicio proyecto
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaInicio ? s.fechaInicio.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaInicio", e.target.value)}
            disabled={(!permissions.isAdmin && !permissions.isBossArea)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 22) Información enviada
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${infoEnviadaMapColor[s.informacionEnviada]}`}>
            <select 
              value={s.informacionEnviada}
              onChange={(e) => {
                handleUpdateField("informacionEnviada", e.target.value);
              }}
              className={`text-xs rounded-md px-2 py-1 border border-gray-300
                ${s.informacionEnviada === "No envió nada" ? "text-red-500" : 
                  s.informacionEnviada === "Envió poco" ? "text-yellow-400" : 
                  s.informacionEnviada === "Envió todo" ? "text-green-500" : 
                  "text-gray-500"}`}
              disabled={!permissions.isAdmin && !permissions.isUserArea}
            >
              <option value="Por confirmar" className="text-black">Por confirmar</option>
              <option value="No envió nada" className="text-red-500">No envió nada</option>
              <option value="Envió poco" className="text-yellow-400">Envió poco</option>
              <option value="Envió todo" className="text-green-500">Envió todo</option>
            </select>
          </span>
        </td>
      ),
    },

    // 23) Fecha envío info al 100%
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.fechaInfoCompleta ? formatDate(s.fechaInfoCompleta.split("T")[0]) : "-"}
        </td>
      ),
    },

    // 24) Vendedor
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.cotizacion?.cotizador?.name ? `${s.cotizacion?.cotizador?.name}` : "-"}
        </td>
      ),
    },

    // 25) Fecha entrega
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.fechaEntrega ? formatDate(s.fechaEntrega.split("T")[0]) : "-"}
        </td>
      ),
    },

    // 26) Duración del proyecto establecido
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {Math.ceil((new Date(s.fechaFin).getTime() - new Date(s.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}
        </td>
      ),
    },

    // 27) Duración (hasta la fecha si esta en proceso)
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.estado === 'Terminado con exito' ? (
            s.fechaInicio && s.fechaEntrega ? (
                Math.ceil((new Date(s.fechaEntrega).getTime() - new Date(s.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))
            ) : (
              "-"
            )
          ) : (
            s.fechaInicio ? (
              Math.ceil((new Date().getTime() - new Date(s.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))
            ) : (
              "-"
            )
            )}                          
        </td>
      ),
    },

    // 28) Duración real del proyecto
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.fechaInfoCompleta ? (
            s.estado === "En proceso"
              ? Math.ceil((new Date().getTime() - new Date(s.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
              : s.estado === "Terminado con exito" && s.fechaEntrega
              ? Math.ceil((new Date(s.fechaEntrega).getTime() - new Date(s.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
              : "N/A"
          ) : "N/A"}                          
        </td>
      ),
    },

    // 29) Precio venta
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {(() => {
            const servicioEncontrado = softwareServices.find(
              (e) => e.id === s.servicio.id
            );

            const precioUnitario = servicioEncontrado?.preciosUnitarios?.find(
              (ev2) => ev2.plan?.id === s.planServicio?.id
            )?.precio;

            const precioBase = s.customPriceActive
              ? s.customPrice * s.numeroItems
              : precioUnitario
              ? precioUnitario * s.numeroItems
              : 0;

            let montoDescuento = 0;
            if (s.tipoDescuento === "Porcentaje") {
              montoDescuento = precioBase * (s.montoDescuento / 100);
            } else if (s.tipoDescuento === "Fijo") {
              montoDescuento = s.montoDescuento;
            }

            return "S/. " + (precioBase - montoDescuento).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}                      
        </td>
      ),
    },

    // 30) Link desarrollo
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkDesarrollo ? (
              <DetailsButton 
                action={() => {window.open(linkDesarrollo, "_blank")}}
                content={linkDesarrollo ? linkDesarrollo : "No hay link de desarrollo"}  
              >
                {linkDesarrollo ? linkDesarrollo : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 31) Link oficial
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkOficial ? (
              <DetailsButton
                action={() => {window.open(linkOficial, "_blank")}}
                content={linkOficial ? linkOficial : "No hay link oficial"}  
              >
                {linkOficial ? linkOficial : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 32) Copia seguridad referencia
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {copiaSeguridadRef ? (
              <DetailsButton
                action={() => {window.open(copiaSeguridadRef, "_blank")}}
                content={copiaSeguridadRef ? copiaSeguridadRef : "No hay copia seguridad"}  
              >
                {copiaSeguridadRef ? copiaSeguridadRef : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 33) Capacitación hecha
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${capacitacionHechaMapColor[s.capacitacionHecha]}`}>
            {s.capacitacionHecha}
          </span>
        </td>
      ),
    },

    // 34) Control de calidad
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.controlCalidad}
            disabled={!permissions.isAdmin && !permissions.isAssistant}
            onChange={(e) => {handleUpdateField("controlCalidad", e.target.value)}}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            <option value="Pendiente" className="text-gray-500">Pendiente</option>
            <option value="Si" className="text-green-500">Si</option>
            <option value="No" className="text-red-500">No</option>
          </select>
        </td>
      ),
    },

    // 35) Link Github
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkGithub ? (
              <DetailsButton
                action={() => {window.open(linkGithub, "_blank")}}
                content={linkGithub ? linkGithub : "No hay link de Github"}  
              >
                {linkGithub ? linkGithub : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 36) Link flujo
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkFlujo ? (
              <DetailsButton
                action={() => {window.open(linkFlujo, "_blank")}}
                content={linkFlujo ? linkFlujo : "No hay link de flujo"}  
              >
                {linkFlujo ? linkFlujo : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 37) Link roadmap
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkRoadmap ? (
              <DetailsButton
                action={() => {window.open(linkRoadmap, "_blank")}}
                content={linkRoadmap ? linkRoadmap : "No hay link de roadmap"}  
              >
                {linkRoadmap ? linkRoadmap : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 38) Link esquema
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkEsquemaBaseDatos ? (
              <DetailsButton
                action={() => {window.open(linkEsquemaBaseDatos, "_blank")}}
                content={linkEsquemaBaseDatos ? linkEsquemaBaseDatos : "No hay link del esquema"}  
              >
                {linkEsquemaBaseDatos ? linkEsquemaBaseDatos : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 39) Link manual de uso
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkManualUso ? (
              <DetailsButton
                action={() => {window.open(linkManualUso, "_blank")}}
                content={linkManualUso ? linkManualUso : "No hay link del manual de uso"}  
              >
                {linkManualUso ? linkManualUso : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 40) Link capacitación
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkCapacitacion ? (
              <DetailsButton
                action={() => {window.open(linkCapacitacion, "_blank")}}
                content={linkCapacitacion ? linkCapacitacion : "No hay link de capacitación"}  
              >
                {linkCapacitacion ? linkCapacitacion : "-"}
              </DetailsButton>  
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },
  ]

  const colsWithIds = cols.map((col, index) => ({ ...col, id: index + 1 }))

  return (
    <>
      {createPortal(
        <DrawerCotizacionCalendarioPagosDetails
          onClose={() => setOpenDrawer(false)}
          open={openDrawer}
          dataDrawer={dataDrawer}
          refetch={() => {}}
          isAdmin={permissions.isAdmin}
          paises={[]}
          currencyExchanges={[]}
        />,
        document.body
      )}
      <tr
        key={key}
        className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" }`}
      >

        {/* Columnas dinámicas (ids 1..N) */}
        {colsWithIds.map((colDef) => {
          const isVisible = activeCols?.find((c) => c.id === colDef.id && shouldShowColumn(c))
          if (!isVisible) return null
          return React.cloneElement(colDef.content(), { key: colDef.id })
        })}

      </tr>
    </>
  )
}

export default SoftwareRowItemContainer;
